<div class="sidebar h-100 theme-background theme-color" id="sidebar">
    <div class="pb-0 h-100 position-relative">
        <form (ngSubmit)="filterMenus()" class="nice-scroll overflow-auto pb-3" style="height: 95%;">
            <!-- search field -->
            <div class="mx-3 mt-2 mb-2 menu-search position-relative" (click)="searchover()">
                <i class="las la-search position-absolute cursor-pointer searchIcon"
                    pTooltip="{{'helpers.buttons.searchButton' | translate}}..."
                    tooltipPosition="{{lang==='ar'? 'right':'left'}}" *ngIf="!searchKey"></i>
                <i class="las la-times position-absolute cursor-pointer searchIcon"
                    pTooltip="{{'helpers.buttons.searchButton' | translate}}..."
                    tooltipPosition="{{lang==='ar'? 'right':'left'}}" *ngIf="searchKey" (click)="onReset()"></i>
                <input [(ngModel)]="searchKey" (paste)="filterMenus()" (keyup)="filterMenus()"
                    class="form-control w-100" placeholder="{{'helpers.buttons.searchButton' | translate}}..."
                    autocomplete="on" name="searchKey">
            </div>
            <ul class="list-unstyled p-0 m-0">
                <ng-template [ngTemplateOutlet]="recursiveMenu"
                    [ngTemplateOutletContext]="{ $implicit: filteredMenuItems }">
                </ng-template>
            </ul>
        </form>

        <div class="m-0 text-right position-absolute menu-toggle" pTooltip="{{'helpers.labels.pinMenu' | translate}}"
            tooltipPosition="{{lang==='ar'? 'right':'left'}}">
            <i class="las la-angle-double-left fs-20  px-2 cursor-pointer text-center px-2" (click)="clickpin()"
                id="left-sidemenu-bin-toggler"></i>
        </div>
    </div>
    <!-- <div class="mx-4 mb-2 text-right position-fixed menu-toggle">
      <i class="fa fa-thumbtack fs-14 arco-primary-text px-2 cursor-pointer text-center"
        id="left-sidemenu-bin-toggler"></i>
    </div> -->
</div>
<ng-template #recursiveMenu let-allChildren>
    <ng-container *ngFor="let item of allChildren;">

        <li *ngIf="!item?.isHidden" class="position-relative menu-item {{'MenuID_' + item.MenuId}}" #menuItemLI
            [ngClass]="{'menu-open':ActiveParent(menuItemLI)}" [routerLinkActive]="'active-link'">
            <a (click)="onSetTitle(item.title)" class="menu-link text-truncate" href="javascript:;"
                *ngIf="item.action && item.action.toLowerCase().indexOf('http')===-1" routerLink="{{item?.action}}"
                [ngClass]="{'has-sub-menu first':  item.subMenus && item.subMenus.length>0}"
                [attr.data-toggle]="item?.subMenus && item?.subMenus.length > 0 ? 'collapse' : ''"
                [attr.data-target]="'#' + 'MenuID_' + item.MenuId" aria-expanded="false" aria-controls="allChildren">
                <i class="{{item?.imageUrl}} menu-icon"
                    pTooltip="{{lang==='ar'? (item.titleAr||item.title):item.title}}"
                    tooltipPosition="{{lang==='ar'? 'right':'left'}}"></i>
                <span class="link-text ">{{lang==='ar'? (item.titleAr||item.title):item.title}}</span>
                <i class="las menu-arrow" *ngIf="item.subMenus && item.subMenus.length>0"></i>
            </a>

            <a class="menu-link text-truncate" *ngIf="item.action && item.action.toLowerCase().indexOf('http')>-1"
                target="_blank" href="{{loginUrl + '&returnUrl=' + item?.action }}"
                [ngClass]="{'has-sub-menu second ':  item.subMenus && item.subMenus.length>0}"
                [attr.data-toggle]="item?.subMenus && item?.subMenus.length > 0 ? 'collapse' : ''"
                [attr.data-target]="'#' + 'MenuID_' + item.MenuId" aria-expanded="false" aria-controls="allChildren">
                <i class="{{item?.imageUrl}} menu-icon"
                    pTooltip="{{lang==='ar'? (item.titleAr||item.title):item.title}}"
                    tooltipPosition="{{lang==='ar'? 'right':'left'}}"></i>
                <span class="link-text ">{{lang==='ar'? (item.titleAr||item.title):item.title}}</span>
                <i class="las menu-arrow" *ngIf="item.subMenus && item.subMenus.length>0"></i>
            </a>
            <a class="menu-link text-truncate" *ngIf="!item.action" href="javascript:;"
                [ngClass]="{'has-sub-menu third collapsed':  item.subMenus&&item.subMenus.length>0}"
                [attr.data-toggle]="item?.subMenus && item?.subMenus.length > 0 ? 'collapse' : ''"
                [attr.data-target]="'#' + 'MenuID_' + item.MenuId" aria-expanded="false" aria-controls="allChildren">
                <i class="{{item?.imageUrl}} menu-icon"
                    pTooltip="{{lang==='ar'? (item.titleAr||item.title):item.title}}"
                    tooltipPosition="{{lang==='ar'? 'right':'left'}}"
                    *ngIf="item.subMenus && item.subMenus.length>0"></i>
                <span class="link-text ">{{lang==='ar'? (item.titleAr||item.title):item.title}}</span>
                <i class="las menu-arrow" *ngIf="item.subMenus && item.subMenus.length>0"></i>
            </a>
            <!--  -->
            <div class="menu-submenu collapse" [ngClass]="{'show':isActiveParent(menuItemLI)}"
                [id]="'MenuID_' + item.MenuId" *ngIf="item.subMenus && item.subMenus.length>0">
                <ul class="has-sub second-level">
                    <li class="submenu-title">
                        <span class="link-text text-center">{{lang==='ar'?
                            (item.titleAr||item.title):item.title}}</span>

                    </li>
                    <ng-template [ngTemplateOutlet]="recursiveMenu"
                        [ngTemplateOutletContext]="{ $implicit: item.subMenus }">
                    </ng-template>
                </ul>
            </div>
        </li>
    </ng-container>
</ng-template>
<!-- END: Left Aside -->